import { filter } from 'rxjs/operators';

export function isNotNullOrUndefined<T>() {
  return filter((value: T) => value !== null && value !== undefined);
}

export function isNotEmpty<T>() {
  return filter((value: T[]) => !!value.length);
}
